<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="General">
      <form class="edit-interactive-dialog-form">
        <mat-form-field>
          <mat-label>Name (required, unique, 40 character max)</mat-label>
          <input matInput
                 name="interactName"
                 [(ngModel)]="data.interactive.interactName" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input matInput
                 name="description"
                 [(ngModel)]="data.interactive.description" />
        </mat-form-field>
        <ng-container>
          <mat-checkbox name="data.allowModify" [(ngModel)]="data.interactive.canModify">Allow Modify?</mat-checkbox>
        </ng-container><br />
        <ng-container>
          <mat-checkbox name="data.canPreFilter" [(ngModel)]="data.interactive.canPreFilter">Allow Pre-Filtering?</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-label>Interactive File: ({{ data.interactive.fileName }})</mat-label>
          <input type="file"
                 id="inputFile"
                 (change)="handleFileInput($event.target.files)" />
        </ng-container>
        <ng-container *ngIf="uploadingInteractive">
          <b>Uploading Interactive, Please Wait....</b>
        </ng-container>
      </form>
    </mat-tab>
    <mat-tab label="Print on Demand Pages">
      <div class="row">
        <div class="col-md-2" style="text-align: center"><b>Order</b></div>
        <div class="col-md-4" style="text-align: center"><b>Display Name</b></div>
        <div class="col-md-4" style="text-align: center"><b>PBIX Page</b></div>
        <div class="col-md-2" style="text-align: center"><b>Action</b></div>
      </div>
      <ng-container *ngFor="let page of podData">
        <div class="row">
          <div class="col-md-2">
            <ng-container *ngIf="page.order !== 0">
              <a href="#" (click)="movePageUp(page)"><span class="fas fa-arrow-up" title="Move Page Up"></span></a>
            </ng-container>
            <ng-container *ngIf="page.order !== (podData.length - 1)">
              <a href="#" (click)="movePageDown(page)"><span class="fas fa-arrow-down" title="Move Page Down"></span></a>
            </ng-container>
          </div>
          <div class="col-md-4">
            <input matInput [(ngModel)]="page.displayName" placeholder="Display Name" />
          </div>
          <div class="col-md-4">
            <input matInput [(ngModel)]="page.page" placeholder="PBIX Name" />
          </div>
          <div class="col-md-2">
            <a href="#" (click)="removePage(page)"><span class="fas fa-trash" title="Delete Page"></span></a>
          </div>
        </div>
      </ng-container>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <input matInput [(ngModel)]="newPageDisplayName" placeholder="Display Name" />
        </div>
        <div class="col-md-4">
          <input matInput [(ngModel)]="newPagePage" placeholder="PBIX Name" />
        </div>
        <div class="col-md-2">
          <a href="#" (click)="addPage()"><span class="fas fa-check" title="Add Page"></span></a>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Pre-Filter Selections">
      <div class="row">
        <div class="col-md-3" style="text-align: center"><b>Filter Type</b></div>
        <div class="col-md-7" style="text-align: center"><b>Data Set Object Path</b></div>
        <div class="col-md-2"></div>
      </div>
      <ng-container *ngFor="let interactFilterType of interactFilterTypes">
        <div class="row">
          <div class="col-md-3">
            <mat-select [(ngModel)]="interactFilterType.filterTypeId">
              <mat-option *ngFor="let type of filterTypes" [value]="type.filterTypeId">{{type.title}}</mat-option>
            </mat-select>
          </div>
          <div class="col-md-7">
            <input matInput [(ngModel)]="interactFilterType.fullDataSetObjectPath" />
          </div>
          <div class="col-md-2">
            <a href="#" (click)="removeFilter(interactFilterType)"><span class="fas fa-trash" title="Delete Filter"></span></a>
          </div>
        </div>
      </ng-container>
      <div class="row">
        <div class="col-md-3">
          <mat-select [(ngModel)]="newFilterType">
            <mat-option *ngFor="let type of filterTypes" [value]="type">{{type.title}}</mat-option>
          </mat-select>
        </div>
        <div class="col-md-7">
          <input  matInput [(ngModel)]="newFilterObjectPath" />
        </div>
        <div class="col-md-2">
          <a href="#" (click)="addFilterType()"><span class="fas fa-check" title="Add Filter"></span></a>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
